/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `done` - done
 * * `in_progress` - in_progress
 * * `not_started` - not_started
 * @export
 */
export const CustomQuestionnaireStatusStatusEnum = {
  done: 'done',
  inProgress: 'in_progress',
  notStarted: 'not_started',
} as const;
export type CustomQuestionnaireStatusStatusEnum =
  (typeof CustomQuestionnaireStatusStatusEnum)[keyof typeof CustomQuestionnaireStatusStatusEnum];

export function instanceOfCustomQuestionnaireStatusStatusEnum(value: any): boolean {
  for (const key in CustomQuestionnaireStatusStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(CustomQuestionnaireStatusStatusEnum, key)) {
      if ((CustomQuestionnaireStatusStatusEnum as Record<string, CustomQuestionnaireStatusStatusEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CustomQuestionnaireStatusStatusEnumFromJSON(json: any): CustomQuestionnaireStatusStatusEnum {
  return CustomQuestionnaireStatusStatusEnumFromJSONTyped(json, false);
}

export function CustomQuestionnaireStatusStatusEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireStatusStatusEnum {
  return json as CustomQuestionnaireStatusStatusEnum;
}

export function CustomQuestionnaireStatusStatusEnumToJSON(value?: CustomQuestionnaireStatusStatusEnum | null): any {
  return value as any;
}
